import Config from '../../config/Config'
import { filter, map, mergeMap, catchError } from 'rxjs/operators'
import { of } from 'rxjs'
import { ajax } from 'rxjs/ajax'
import * as actions from './actions'

// GET /v2/feature_flag
export const getFeatureFlag = (action$ /* state$ */) => {
  // Variables with $ indicate a stream...
  return action$.pipe(
    filter((action) => action.type === actions.GET_FEATURE_FLAG),
    mergeMap((action) => {
      const { id } = action.payload
      const settings = {
        method: 'GET',
        responseType: 'json',
        url: `${Config.API_BASE}/v2/feature_flags/${id}`,
      }
      return ajax(settings).pipe(
        map((payload) => {
          return {
            type: actions.GET_FEATURE_FLAG_FULFILLED,
            payload: payload.response,
          }
        }),
        catchError((payload) => {
          return of({
            type: actions.GET_FEATURE_FLAG_REJECTED,
            payload: payload.response,
          })
        }),
      )
    }),
  )
}
